import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import RouteNavigation from "@/components/RouteNavigation";
import ExpertisePage from "@/pages/ExpertisePage";

import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminGuard from "@/components/AdminGuard";

function App() {
  return (
    <BrowserRouter>
      <RouteNavigation />
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/services" element={<ExpertisePage kind="services" />} />
        <Route path="/industries" element={<ExpertisePage kind="industries" />} />

        {/* Admin login */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Protected admin */}
        <Route
          path="/admin"
          element={
            <AdminGuard>
              <AdminPage />
            </AdminGuard>
          }
        />
      </Routes>

      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
